import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { EffectFade } from 'swiper/modules';

window.Drupal.behaviors.imageSliderWithTextCtaSwiper = {
    attach: function (context) {
        once('image-slider-with-text-cta', '.image-slider-with-text-cta', context).forEach((selector) => {
            new Swiper(selector.querySelector('.swiper'), {
                modules: [Navigation, EffectFade],
                navigation: {
                    nextEl: selector.querySelector('.swiper-button-next'),
                    prevEl: selector.querySelector('.swiper-button-prev'),
                },
                speed: 800,
                autoHeight: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
            });
        });
    },
};
